import Layout, { PageHeader } from "../components/Layout";
import { DeliverablesMatrix } from "./Sponsorship";

export default function Deliverables() {
  return (
    <Layout>
      <PageHeader
        overline="Reference"
        title="Deliverables"
        subtitle="What each sponsorship & activation tier receives — pre-event, during event, and post-event."
        testId="deliverables-header"
      />
      <DeliverablesMatrix />
    </Layout>
  );
}
